const STR_RENDER_STRATEGY = /data-str-render-strategy="(ps|div|iframe)"/;

export const getRenderStrategy = (adm: string) => {
  return adm.match(STR_RENDER_STRATEGY) && (adm.match(STR_RENDER_STRATEGY) as NonNullable<Array<string>>)[1];
};
